export const setValue = name => value => ({
  type: "SET",
  name,
  value,
})
